import { useMissionsTranslation } from '../../../../ui/hooks';
import { convertMillisecondsToHours } from '../../../../ui/utils/convertMillisecondsToHours';
import { TransparentBox } from '@juvare/common-web-ui/TransparentBox';
import { Box, Typography } from '@mui/material';
import React from 'react';
export const MissionPlaceholders = ({ missionsCount, volunteerHours }) => {
    const { t } = useMissionsTranslation();
    const placeholdersDetails = [
        {
            label: t('missions.missions'),
            count: missionsCount,
            dataTest: 'total-missions-transparent-box',
        },
        {
            label: t('missions.volunteerHours'),
            count: convertMillisecondsToHours(volunteerHours),
            dataTest: 'total-volunteer-hours-transparent-box',
        },
    ];
    return (React.createElement(React.Fragment, null, placeholdersDetails.map((placeholder) => (React.createElement(Box, { key: placeholder.label, sx: { width: '100%' } },
        React.createElement(TransparentBox, { "data-test": placeholder.dataTest },
            React.createElement(Box, { sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1,
                } },
                React.createElement(Typography, { component: 'p', variant: 'h4', sx: { wordWrap: 'break-word' } }, placeholder.count),
                React.createElement(Typography, { variant: 'body2', sx: { wordWrap: 'break-word' } }, placeholder.label))))))));
};
